import { Box } from "@mantine/core";
import { useDebouncedState } from "@mantine/hooks";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { IRootState } from "config/redux";

import { Button, Modal, TextInput } from "components";
import { ServiceConstants } from "constant";import { ControlService } from "services";
import { AppUtils } from "utils";;

const { REQUEST_PENDING, REQUEST_CONTROL_F1 } = ServiceConstants;

const title = "F1: Obriši korisnika";

const F1DeleteUser = () => {
  const serviceObject = useSelector((state: IRootState) => state.service.object[REQUEST_CONTROL_F1]);
  const [modalVisible, setModalVisible] = useState<boolean>(false);
  const [email, setEmail] = useDebouncedState('', 500);

  const isLoading = useMemo(() => serviceObject && serviceObject.status === REQUEST_PENDING, [serviceObject]);
  const submit = useCallback(() => ControlService.deleteUserData(email), [email]);

  useEffect(() => {
    AppUtils.resolveServiceObject(serviceObject, REQUEST_CONTROL_F1, () => setModalVisible(false));
  }, [serviceObject]);

  return (
    <>
      <Button variant={'subtle'} onClick={() => setModalVisible(true)}>{title}</Button>
      <Modal opened={modalVisible} onClose={() => !isLoading ? setModalVisible(false) : {}} title={title} style={{ overflowY: 'auto' }}>
        <TextInput
          placeholder={'Unesi email'}
          onChange={(e) => setEmail(e.target.value)}
          autoFocus={true}
        />
        <Box mt={40}>
          <Button
            fullWidth={true}
            disabled={isLoading || email.trim().length === 0}
            loading={isLoading}
            onClick={submit}
          >
            {'Potvrdi'}
          </Button>
        </Box>
      </Modal>
    </>
  )
}

export default F1DeleteUser;